import React from "react";
import Card from "../../../../componets/Card";
import { MainSkinInterface } from "../../../../store/mine_craft/mainSkinsSlice";

const _Details = ({ mainSkin }: { mainSkin: MainSkinInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {mainSkin?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {mainSkin?.body}
      </Card>
    </>
  );
}

export default _Details;
